module.exports = __webpack_public_path__ + "img/qrQQ.e36f4dd1.png";